'use strict'

var curry = require('./curry')

module.exports = curry(function(prop, value){
    return value != undefined? value[prop]: undefined
})


/*****************
 ** WEBPACK FOOTER
 ** ./~/functionally/src/dot.js
 ** module id = 845
 ** module chunks = 0
 **/